import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadSchedules as loadSchedulesAction } from 'redux/modules/schedule';

import { ScheduleRenderer } from './ScheduleRenderer';

const mapStateToProps = ({ shared, schedule }) => ({
  vertical: shared.vertical,
  // schedule items are pre-formatted in redux/modules/schedule
  formattedSchedule: schedule.formattedItems,
});

/**
 * Data-fetching layer of the custom Schedule package. Fetches and passes schedule feed data to
 * functional Schedule renderer
 */
class Schedule extends React.Component {
  static propTypes = {
    formattedSchedule: PropTypes.shape({}),
    vertical: PropTypes.string.isRequired,
    content: PropTypes.shape({
      metadata: PropTypes.shape({
        title: PropTypes.string,
      }),
    }).isRequired,
  };

  static contextTypes = {
    store: PropTypes.shape({}),
  };

  static defaultProps = {
    formattedSchedule: null,
  };

  componentDidMount() {
    const { formattedSchedule, vertical } = this.props;
    const { store } = this.context;

    if (!formattedSchedule) {
      store.dispatch(loadSchedulesAction(vertical));
    }
  }

  render() {
    const { formattedSchedule, content: { metadata } } = this.props;
    const { title = 'Schedule Page' } = metadata;

    return (
      <ScheduleRenderer title={title} schedule={formattedSchedule || {}} />
    );
  }
}

export default connect(mapStateToProps)(Schedule);
